import { TitleCasePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { HtmlMarkdownService } from "@hub-services/html-markdown.service";

@Pipe({name: 'historyDetailsFormat'})
export class HistoryDetailsFormatPipe implements PipeTransform {

    constructor(private htmlMarkdownService: HtmlMarkdownService) {}

    transform(allLogEntries: any) {
        const titleCasePipe = new TitleCasePipe();
        let allLogEntryArray: string[] = Array();
        const filteredLogEntries = this.filterCabinEntriesForBrandChanges(allLogEntries);
        for (const logEntry of filteredLogEntries) {
            logEntry.changes = this.convertMarkdownToHtml(logEntry);
            let itemType : string = logEntry.item_type;
            if(itemType && itemType === 'SeatCharacteristic'){
                let arr: string[] = Array();
                this.keyValConverter(logEntry.changes).forEach(element => {
                    arr.push(element.val);
                });
                allLogEntryArray.push("Seat Characteristics: <br/>" + arr.join(" | ")+"<br/>");
            }
            else{
                let output = "";
                for(let keyVal of this.keyValConverter(logEntry.changes)){
                let concatenatedValues = this.concatenateValues(keyVal.val, keyVal.key, logEntry.action);
                if(concatenatedValues.length > 0){
                    let prefix = "";
                    let lowerCaseKey = keyVal.key.toLowerCase();
                    switch (lowerCaseKey) {
                        case 'position':
                            prefix = itemType+' ';
                            break;
                        case 'starts at':
                        case 'ends at':
                            prefix = 'Display Date ';
                            break;
                        case 'rule':
                            prefix = 'Targeting ';
                            break;
                        case 'description_md':
                            keyVal.key = 'Formatted Description';
                            break;
                        case 'caption_md':
                            keyVal.key = 'Formatted Caption';
                            break;
                        case 'cta_text':
                            keyVal.key = 'External site link';
                            break;
                        case 'cta_url':
                            keyVal.key = 'External site URL';
                            break;
                    }
                    output = output + '<b>' + prefix + titleCasePipe.transform(keyVal.key) + ':</b> ' + concatenatedValues + (['description_md', 'caption_md'].includes(lowerCaseKey) ? '' : '<br/>');
                }
                }
                allLogEntryArray.push(output);
            }
    }
    return allLogEntryArray.join("");
}
    concatenateValues(values?: any, key?: string, action?:string): string{
        let arr: string[] = Array();
        for (var val of values) {
            if(key?.toLowerCase() === 'caption' && val){
                val = val.replace(/[{}]/g, "");
            } else if (key?.toLowerCase() === 'status') {
              val = val === 'in_review' ? 'In review' : val.charAt(0).toUpperCase() + val.slice(1);
            } 
            if(action === 'update'){
                if((val === null) || (val.length === 0)){
                    arr.push('None');
                }
                else{
                    arr.push(val);
                }
            }
            else{
                if(val){
                    arr.push(val);
                }
            }
        }
        if(key){
            let lowerCaseKey = key.toLowerCase();
            if (['category', 'rule', 'brand', 'comment'].includes(lowerCaseKey)) { 
                return arr.join("");  
            }
        } 
          return arr.join(" -> ");
    }

    keyValConverter(value? : {[key:string]:string})
    {
        if (!value) return [];
        return Object.keys(value).map(key => ({key:key, val:value[key]}));

    }

    private convertMarkdownToHtml(logEntry: any): any {
        Object.keys(logEntry.changes).forEach(key => {
            if (key === 'description_md' && !logEntry.isParsed) {
                logEntry.isParsed = true;
                logEntry.changes.description_md.forEach((description_md: string, i: number) => {
                    if (description_md) logEntry.changes.description_md[i] = this.htmlMarkdownService.parseMarkdownToHtml(description_md).slice(0, -1);
                })
            
            } else if (key === 'caption_md' && !logEntry.isParsed) {
                logEntry.isParsed = true;
                let nonDefaultLanguageCodes: string[] = [];
                logEntry.changes.caption_md.reverse().forEach((captionDataRaw: string, i: number) => {
                    if (captionDataRaw) {
                        const captionData: Record<string, string> = JSON.parse(captionDataRaw);
                        let captionDataKeys = Object.keys(captionData);
                        
                        // caption_md[0] representes the previous caption_md value
                        // this captionData does not contain language codes that were previously empty and then changed,
                        // add the missing language codes to the captionData
                        let missingLanguageCodes = nonDefaultLanguageCodes.filter(languageCode => !captionDataKeys.includes(languageCode))
                        missingLanguageCodes.forEach(languageCode => {
                            captionData[languageCode] = '';
                        })
                        captionDataKeys.push(...missingLanguageCodes);

                        let captionDataAsString = '';
                        captionDataKeys.forEach(key => {
                            if (!key.includes('default')) {
                                if (i === 0) {
                                    nonDefaultLanguageCodes.push(key)
                                }
                                if (captionData[key] === '') captionData[key] = 'None';
                                captionData[key] = this.htmlMarkdownService.parseMarkdownToHtml(captionData[key]).slice(0, -1);
                                captionDataAsString += key + ': ' + captionData[key];
                            }
                        });
                        
                        logEntry.changes.caption_md[i] = captionDataAsString;
                    }
                })
                logEntry.changes.caption_md.reverse();
            }
        })
        return logEntry.changes;

    }

    private filterCabinEntriesForBrandChanges(allLogEntries: any[]): any[] {
        if (!allLogEntries.some(logEntry => this.isBrandChange(logEntry))) {
            return allLogEntries;
        }

        return allLogEntries.filter(logEntry => logEntry.item_type !== 'Cabin');
    }

    private isBrandChange(logEntry: any): boolean {
        return logEntry.item_type === 'Brand' || Object.keys(logEntry.changes || {}).some(key => key.toLowerCase() === 'brand');
    }
}
